import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {SettingsState} from '../../../interfaces/reducers/settings';

const initialState: SettingsState = {
  darkMode: false,
};

export const settingsSlice = createSlice({
  name: 'settings',
  initialState,
  reducers: {
    setDark: (state, action: PayloadAction<{darkMode: boolean}>) => {
      state.darkMode = action.payload.darkMode;
    },
    setIsUserVoiceInteractionPlayed: state => {
      state.isUserVoicePlayed = true;
    },
    setIsTabVoiceInteractionPlayed: state => {
      state.isTabVoicePlayed = true;
    },
    resetTabsVoice: state => {
      state.isTabVoicePlayed = false;
      state.isUserVoicePlayed = false;
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  setDark,
  setIsUserVoiceInteractionPlayed,
  setIsTabVoiceInteractionPlayed,
  resetTabsVoice,
} = settingsSlice.actions;

export default settingsSlice.reducer;
